import FamilySection from "../../components/FamilySection";

export default function YouFamily() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-8 md:py-12" data-testid="you-family-page">
      <div className="mb-2">
        <p className="label-tag mb-3">You · Family</p>
        <h1 className="heading-h1 text-4xl sm:text-5xl mb-2">Family.</h1>
        <p className="text-sand-600 text-base mt-3">Share trips with your household — invite adults and viewers.</p>
        <div className="divider-strong mt-4" />
      </div>
      <FamilySection />
    </main>
  );
}
